import PropertyValue from '../../services/property-value';

export const enum BookingMode {
    ToAirport, FromAirport, DoorToDoor
}

export const returnMode = new PropertyValue(false);
export const currentMode = new PropertyValue(BookingMode.FromAirport);

export let isAndroid: boolean = navigator.userAgent.toLowerCase().indexOf('android') > -1;
export let isIOS: boolean = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export let isDesktop: boolean = typeof window.matchMedia === 'function'
    ? window.matchMedia('(min-device-width: 768px)').matches
    : screen.width >= 768;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/storage.ts